import { render } from "./select-asset-category.vue?vue&type=template&id=19fe23c9&scoped=true&ts=true"
import script from "./select-asset-category.vue?vue&type=script&lang=ts"
export * from "./select-asset-category.vue?vue&type=script&lang=ts"

import "./select-asset-category.vue?vue&type=style&index=0&id=19fe23c9&lang=scss&scoped=true"
/* custom blocks */
import block0 from "../../i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Fcomponents%2Flead-form%2Fcomponents%2Fselect-asset-category%2Fselect-asset-category.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fe23c9"]])

export default __exports__